module.exports = __webpack_public_path__ + "static/clock-47099b4f75ec2d2623eff60a06001308.gif";